import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import Container from '@mui/material/Container';
import Swal from 'sweetalert2';
import { FormLabel } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import request from '../../services/Request';
import '../user/form.css';
import { Modal } from '../../components/BootstrapToMUI';
import { Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const updateAlert = '/machines/updateEmailAlert';

export default function TransactionMoal(props) {
  const {
    reset,
    handleSubmit,
    register,
    setError,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useForm({});
  const classes = useStyles();
  const { data, user, setMachines, setRowData, machines, ...rest } = props;
  const showSecondEmail = user.fullAccess && user.dba;
  const watchAll = watch();

  const [loading, setLoading] = useState(true);

  const defaultValues = {};

  useEffect(() => {
    const initializeForm = async () => {
      if (props.show) {
        reset(defaultValues);
      }
    };
    initializeForm();
  }, [props.show]);

  const onSubmit = async (formData) => {
    if (formData.alertEmail.split(',').length > 3) {
      setError('alertEmail', {
        message: 'Maximum 3 email address',
      });
    } else {
      if (showSecondEmail) {
        if (formData.alertEmail2.split(',').length > 3) {
          setError('alertEmail2', {
            message: 'Maximum 3 email address',
          });
        }
      }
      setLoading(false);

      const machineID = data.map((e) => e._id);

      await request({
        method: 'post',
        url: updateAlert,
        data: {
          machineID: machineID,
          alertEmail: formData.alertEmail.trim(),
          alertEmail2: formData?.alertEmail2?.trim(),
        },
      })
        .then((res) => {
          setLoading(true);

          setMachines((prevMachines) =>
            prevMachines.map((e) =>
              machineID.includes(e._id)
                ? {
                    ...e,
                    alertEmail: formData.alertEmail.trim(),
                    alertEmail2: formData?.alertEmail2?.trim(),
                  }
                : e
            )
          );

          setRowData((prevRowData) =>
            prevRowData.map((e) => ({
              ...e,
              alertEmail: formData.alertEmail.trim(),
              alertEmail2: formData?.alertEmail2?.trim(),
            }))
          );

          Swal.fire({
            text: `Your changes has been updated!`,
            icon: 'success',
          }).then(() => {
            props.onHide();
          });
        })
        .catch((error) => {
          setLoading(true);
          Swal.fire({
            text: error?.response?.data?.message || 'Failed to update alert email',
            icon: 'error',
          });
        });
    }
  };

  return (
    <Modal className="modal-w" {...rest} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: '1.2rem' }}>
          Update Settings
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Container component="main" maxWidth="lg">
          <CssBaseline />
          <div>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)} noValidate>
              <Grid container spacing={2}>
                <Grid item xs={12} style={{ textAlignLast: 'center' }}>
                  <FormLabel component="legend">
                    Email address for transaction (To use more than one email address, separate the
                    addresses with comma, up to 3 email adresses. Example:
                    johndoe@ae.com,william@ba.com,smith.peter@olk.com)
                  </FormLabel>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Email"
                    {...register('alertEmail', {})}
                  />
                  {errors.alertEmail && (
                    <p className="signUpErrorMessage">{errors.alertEmail.message}</p>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <p style={{ marginBottom: '10px' }}>Send Transaction every</p>
                  <Controller
                    render={({ field }) => (
                      <Select fullWidth defaultValue="week" {...field} variant="outlined">
                        <MenuItem value="day" key="day">
                          Day
                        </MenuItem>
                        <MenuItem value="week" key="week">
                          Week
                        </MenuItem>
                        <MenuItem value="month" key="month">
                          Month
                        </MenuItem>
                      </Select>
                    )}
                    name="period"
                    control={control}
                  />
                </Grid>
              </Grid>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={!loading}
                color="primary"
                className={classes.submit}
              >
                Update
              </Button>
            </form>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
